import { useDelayedFlag } from '@/shared/hooks';
import type { ReactElement, ReactNode } from 'react';

type DelayedSkeletonGateProps = {
  show: boolean;
  delayMs?: number;
  fallback: ReactNode;
  children: ReactNode;
};

export const DelayedSkeletonGate = ({
  show,
  delayMs = 200,
  fallback,
  children,
}: DelayedSkeletonGateProps): ReactElement => {
  const shouldShow = useDelayedFlag(show, delayMs);

  if (shouldShow) {
    return <>{fallback}</>;
  }

  if (show) {
    return <></>;
  }

  return <>{children}</>;
};
